import { z } from 'zod';
import type { Gender } from '../enums.js';

export interface InstitutionGroupMemberInfo {
  id: string;
  member_id: string;
  practitioner: {
    id: string;
    email: string;
    profile: {
      gender: Gender;
      first_name: string;
      last_name: string;
      avatar_url: string | null;
    } | null;
  };
}

export interface InstitutionGroup {
  id: string;
  institution_id: string;
  name: string;
  description: string;
  members: InstitutionGroupMemberInfo[];
  created_at: string;
  updated_at: string;
}

export const createInstitutionGroupSchema = z.object({
  name: z.string().min(1, 'Group name is required').max(100),
  description: z.string().max(500).optional().default(''),
});

export type CreateInstitutionGroupPayload = z.infer<typeof createInstitutionGroupSchema>;

export const updateInstitutionGroupSchema = z.object({
  name: z.string().min(1, 'Group name is required').max(100).optional(),
  description: z.string().max(500).optional(),
});

export type UpdateInstitutionGroupPayload = z.infer<typeof updateInstitutionGroupSchema>;

export const institutionGroupParamsSchema = z.object({
  group_id: z.uuid(),
});

export type InstitutionGroupParams = z.infer<typeof institutionGroupParamsSchema>;

export const addGroupMemberSchema = z.object({
  member_id: z.uuid(),
});

export type AddGroupMemberPayload = z.infer<typeof addGroupMemberSchema>;

export const removeGroupMemberParamsSchema = z.object({
  group_id: z.uuid(),
  member_id: z.uuid(),
});

export type RemoveGroupMemberParams = z.infer<typeof removeGroupMemberParamsSchema>;
